/** Sentinel audit trail — tamper-proof record of every action (SOC 2 / CMS-ready). */
import { useState, useEffect } from 'react';
import { api, Spinner, EmptyState, Hint, dateTime } from './ui';

const EVENT_LABEL = {
  case_created: 'Case created', case_updated: 'Case updated', dispositioned: 'Case dispositioned',
  note_added: 'Note added', record_request_created: 'Records requested', record_request_updated: 'Records request updated',
  overpayment_recorded: 'Overpayment recorded', referral_built: 'Referral built', agent_run: 'AI assistant used',
  reporter_unmasked: 'Reporter identity revealed',
};

export default function SentinelAudit() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/audit').then((j) => setEvents(j.events || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="font-semibold text-slate-800 flex items-center mb-1">Audit trail<Hint text="Every action across all cases, in permanent ink. This append-only log can't be edited or deleted — exactly what a CMS program audit and your SOC 2 review want to see." /></h2>
      <p className="text-sm text-slate-500 mb-4">Append-only and tamper-evident. Retained for audit readiness.</p>
      {events.length === 0 ? <EmptyState title="No activity yet" hint="Actions will appear here as you work cases." /> : (
        <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
          {events.map((e) => (
            <div key={e.id} className="px-4 py-3 flex items-center gap-3 text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-slate-300 flex-shrink-0" />
              <span className="font-medium text-slate-700">{EVENT_LABEL[e.event_type] || e.event_type}</span>
              {e.case_number && <span className="text-xs font-mono text-slate-400">{e.case_number}</span>}
              <span className="text-slate-500 truncate">{e.summary}</span>
              <span className="ml-auto text-xs text-slate-400 flex-shrink-0">{dateTime(e.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
